import { Radio } from '@mui/material';
import { getHtmlText } from 'components/organisms/HtmlSlate';
import { IVaryDataVariations } from 'models/licence';
import { ITableColumns, ITableDataSource } from 'models/table';

export const mapVariationsToDataSource = (items: IVaryDataVariations[]): ITableDataSource[] =>
  items.map((item) => ({
    id: item.uniqueId,
    name: item.name,
    fee: item.fee,
    description: item.description,
    documents: item.documents,
  }));

interface IVariationsTableColumns {
  handleCheck: (id: string) => void;
  checkedId: string;
  currency: string;
}

export const variationsTableColumns = ({
  handleCheck,
  checkedId,
  currency,
}: IVariationsTableColumns): ITableColumns[] => [
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f518',
      key: '',
      title: '',
      isSortable: false,
      align: 'center',
      width: '43px',
      isCenterTableHead: true,
      render: (_data, props) => (
        <Radio
          checked={props.id === checkedId}
          onChange={() => handleCheck(props)}
          style={{ padding: 0, width: '16px' }}
        />
      ),
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
      key: 'name',
      title: 'caseManagement.licence.vary.name.column',
      isSortable: false,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f513',
      key: 'fee',
      title: 'caseManagement.licence.vary.fee.column',
      isSortable: false,
      render: (_data, props) => `${props.fee} ${currency}`,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f514',
      key: 'description',
      title: 'caseManagement.licence.vary.description.column',
      isSortable: false,
      render: (_data, props) => getHtmlText(props.description),
    },
  ];
